export default {
    OUTRO: 13,
}